import { NavLink, Outlet, Navigate } from "react-router-dom";
import { LayoutDashboard, ClipboardList, UserRound, FileText, Mail, History } from "lucide-react";
import { HelpButton } from "../../components/site/HelpButton";
import { useAuth } from "../../lib/auth";
import { useLang } from "../../lib/i18n";
import { fileUrl } from "../../lib/api";
import { profilePhoto } from "./Profile";

export default function AccountLayout() {
  const { user } = useAuth();
  const { t } = useLang();
  if (user === null) return <div className="h-screen" />;
  if (!user) return <Navigate to="/login?next=/account" />;
  if (user.role === "admin") return <Navigate to="/admin" />;
  const items = [["", LayoutDashboard, "acc_overview"], ["profile", UserRound, "acc_profile"], ["documents", FileText, "acc_docs"],
    ["registrations", ClipboardList, "acc_regs"], ["history", History, "acc_history"], ["messages", Mail, "acc_msgs"]];
  return (
    <div className="container-x grid gap-8 pb-24 pt-28 lg:grid-cols-12" data-testid="account-layout">
      <aside className="min-w-0 lg:col-span-3">
        <div className="sticky top-28 space-y-6">
          <div className="flex items-center gap-4 rounded-3xl bg-[#0A2540] p-5 text-white">
            <div className="flex h-14 w-14 shrink-0 items-center justify-center overflow-hidden rounded-full bg-[#00A8B5] font-display text-lg font-bold">
              {profilePhoto(user) ? <img src={fileUrl(profilePhoto(user))} alt="" className="h-full w-full object-cover" data-testid="account-avatar-photo" /> : `${user.first_name?.[0] || ""}${user.last_name?.[0] || ""}`}
            </div>
            <div className="min-w-0">
              <p className="truncate font-display font-bold" data-testid="account-user-name">{user.first_name} {user.last_name}</p>
              <p className="truncate text-xs text-white/60">{user.email}</p>
              <p className="truncate text-xs text-[#00A8B5]" data-testid="account-sailors-summary">{t("my_sailors")}: {(user.participants || []).map((p) => p.first_name).join(", ")}</p>
            </div>
          </div>
          <nav className="flex gap-1 overflow-x-auto lg:flex-col">
            {items.map(([to, Icon, k]) => (
              <NavLink key={k} to={`/account${to ? `/${to}` : ""}`} end={!to} data-testid={`account-nav-${to || "overview"}`}
                ref={(el) => window.innerWidth < 1024 && el?.getAttribute("aria-current") === "page" && el.scrollIntoView({ block: "nearest", inline: "center" })}
                className={({ isActive }) => `flex items-center gap-3 whitespace-nowrap rounded-2xl px-4 py-3 text-sm font-semibold transition-colors ${isActive ? "bg-white text-[#0A2540] shadow-sm ring-1 ring-slate-200" : "text-slate-500 hover:text-[#0A2540]"}`}>
                <Icon size={18} />{t(k)}
              </NavLink>
            ))}
          </nav>
        </div>
      </aside>
      <main className="min-w-0 lg:col-span-9"><div className="mb-3 flex justify-end"><HelpButton testid="account-help-button" /></div><Outlet /></main>
    </div>
  );
}
